export default "__VITE_ASSET__fc4ffc65__"